import { categories } from '@/mocks/categories';

export default function Hero() {
  return (
    <section className="relative w-full min-h-screen flex flex-col items-center justify-center pt-24 pb-16 px-4 md:px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dreamy%20soft%20pastel%20abstract%20background%20with%20organic%20flowing%20shapes%20in%20warm%20beige%20cream%20sand%20and%20sage%20green%20tones%20gentle%20gradient%20diffused%20morning%20light%20clean%20minimalist%20aesthetic%20calming%20atmosphere%20perfect%20for%20fashion%20product%20showcase%20no%20text%20no%20sharp%20lines&width=1800&height=1200&seq=hero-bg-v2&orientation=landscape"
          alt="Kakobuy Spreadsheet tło"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/30 via-background-50/20 to-background-50/40"></div>
      </div>

      <div className="relative z-10 w-full max-w-6xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/70 backdrop-blur-sm border border-background-200/40 mb-8">
          <span className="w-2 h-2 rounded-full bg-accent-500"></span>
          <span className="font-label text-xs font-medium text-foreground-700">Kakobuy Spreadsheet Polska</span>
        </div>

        <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight mb-6">
          Odkrywaj najlepsze produkty
          <br />
          dzięki <span className="text-accent-600">Kakobuy Spreadsheet</span>
        </h1>

        <p className="font-body text-base md:text-lg text-foreground-600 max-w-2xl mx-auto mb-10 leading-relaxed">
          Największa baza Kakobuy Spreadsheet dla użytkowników z Polski.
          Przeglądaj aktualne listy produktów i znajdź najlepsze okazje szybciej niż kiedykolwiek.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-label text-base font-semibold rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <i className="ri-arrow-right-up-line text-lg"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-transparent text-foreground-800 font-label text-base font-medium rounded-full border border-foreground-300/40 hover:border-foreground-300 hover:bg-background-50/50 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Kakobuy Spreadsheet
            <i className="ri-external-link-line text-lg"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 max-w-3xl mx-auto">
          {[
            { icon: 'ri-checkbox-circle-line', text: 'Aktualizowane listy produktów' },
            { icon: 'ri-book-open-line', text: 'Szczegółowe poradniki' },
            { icon: 'ri-shield-check-line', text: 'Bezpieczne zakupy' },
            { icon: 'ri-grid-line', text: 'Kategorie produktów' },
          ].map((item, i) => (
            <div key={i} className="flex items-center gap-2 px-3 py-2 rounded-lg bg-background-50/60 backdrop-blur-sm">
              <i className={`${item.icon} text-accent-500 text-base`}></i>
              <span className="font-label text-xs font-medium text-foreground-700 whitespace-nowrap">{item.text}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="relative z-10 w-full max-w-5xl mx-auto mt-8">
        <div className="grid grid-cols-3 md:grid-cols-5 gap-3 md:gap-4 items-end">
          {categories.slice(0, 5).map((cat, i) => {
            const heights = ['h-36', 'h-44', 'h-52', 'h-40', 'h-48'];
            const offsets = ['-mt-0', '-mt-4', '-mt-8', '-mt-2', '-mt-6'];
            const imgUrls = [
              "https://readdy.ai/api/search-image?query=Lifestyle%20shot%20of%20pristine%20white%20designer%20sneakers%20on%20sunlit%20wooden%20floor%20warm%20golden%20hour%20light%20streaming%20through%20window%20soft%20bokeh%20background%20cozy%20interior%20aesthetic%20editorial%20product%20photography%20amber%20tones%20natural%20shadows&width=400&height=500&seq=hero-card-v2-01&orientation=portrait",
              "https://readdy.ai/api/search-image?query=Pastel%20sage%20green%20oversized%20hoodie%20draped%20over%20vintage%20wooden%20chair%20near%20bright%20window%20morning%20sunlight%20delicate%20fabric%20texture%20visible%20calm%20bedroom%20atmosphere%20editorial%20fashion%20photography%20gentle%20earthy%20tones&width=400&height=500&seq=hero-card-v2-02&orientation=portrait",
              "https://readdy.ai/api/search-image?query=Vintage%20washed%20black%20graphic%20t-shirt%20flat%20lay%20on%20textured%20marble%20surface%20with%20morning%20coffee%20cup%20nearby%20urban%20cafe%20aesthetic%20soft%20daylight%20editorial%20street%20style%20photography%20moody%20warm%20monochrome%20tones&width=400&height=500&seq=hero-card-v2-03&orientation=portrait",
              "https://readdy.ai/api/search-image?query=Distressed%20light%20wash%20denim%20trucker%20jacket%20hanging%20on%20exposed%20red%20brick%20wall%20industrial%20loft%20interior%20warm%20Edison%20bulb%20lighting%20urban%20chic%20aesthetic%20editorial%20fashion%20photography%20textured%20contrast%20tones&width=400&height=500&seq=hero-card-v2-04&orientation=portrait",
              "https://readdy.ai/api/search-image?query=Artisan%20handmade%20woven%20straw%20tote%20bag%20resting%20on%20weathered%20park%20bench%20with%20fallen%20autumn%20leaves%20golden%20afternoon%20sunlight%20outdoor%20lifestyle%20aesthetic%20editorial%20product%20photography%20warm%20nostalgic%20tones%20bokeh&width=400&height=500&seq=hero-card-v2-05&orientation=portrait",
            ];
            return (
              <a
                key={cat.slug}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className={`${heights[i]} ${offsets[i]} relative rounded-2xl overflow-hidden group cursor-pointer shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1`}
              >
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent z-10"></div>
                <img
                  src={imgUrls[i]}
                  alt={cat.name}
                  className="w-full h-full object-cover object-center"
                />
                <div className="absolute bottom-0 left-0 right-0 z-20 p-3">
                  <span className="font-label text-xs font-semibold text-white">{cat.name}</span>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}